// Función para convertir el documento XML a un objeto JSON
export const xmlToJson = (xml) => {
  const obj = {};

  if (xml.nodeType === 1) {
    // Si el nodo es un elemento
    if (xml.attributes.length > 0) {
      obj['@attributes'] = {};

      for (let i = 0; i < xml.attributes.length; i++) {
        const attribute = xml.attributes.item(i);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType === 3) {
    // Si el nodo es un texto
    obj['@text'] = xml.nodeValue;
  }

  // Recorrer los nodos hijos
  if (xml.hasChildNodes()) {
    for (let i = 0; i < xml.childNodes.length; i++) {
      const item = xml.childNodes.item(i);
      const nodeName = item.nodeName;

      if (typeof obj[nodeName] == 'undefined') {
        obj[nodeName] = xmlToJson(item);
      } else {
        if (typeof obj[nodeName].push == 'undefined') {
          const old = obj[nodeName];
          obj[nodeName] = [];
          obj[nodeName].push(old);
        }

        obj[nodeName].push(xmlToJson(item));
      }
    }
  }

  return obj;
}
